var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecordsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bottom-bar-health-data",
    transform: "translate(-99 -753)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "blankbox",
    width: 16,
    height: 16,
    transform: "translate(99 753)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "records",
    transform: "translate(101.071 755.071)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4355",
    "data-name": "Path 4355",
    d: "M3.176,11.957a14.656,14.656,0,0,0,2.954.3,14.661,14.661,0,0,0,2.954-.3,3.688,3.688,0,0,0,2.874-2.874,14.622,14.622,0,0,0,0-5.907.351.351,0,0,0-.1-.177L9.26.4A.348.348,0,0,0,9.083.3,14.616,14.616,0,0,0,3.176.3,3.687,3.687,0,0,0,.3,3.176a14.609,14.609,0,0,0,0,5.907,3.687,3.687,0,0,0,2.874,2.874m7.951-8.7H10.013A1.01,1.01,0,0,1,9,2.245V1.132ZM.988,3.317A2.987,2.987,0,0,1,3.317.988,13.873,13.873,0,0,1,8.3.873V2.245a1.712,1.712,0,0,0,1.71,1.71h1.372a13.921,13.921,0,0,1-.114,4.987,2.989,2.989,0,0,1-2.329,2.329,13.939,13.939,0,0,1-5.626,0A2.988,2.988,0,0,1,.988,8.942a13.92,13.92,0,0,1,0-5.626",
    transform: "translate(0 0)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4335",
    "data-name": "Path 4335",
    d: "M9.007,24.64h5.57a.35.35,0,0,0,0-.7H9.007a.35.35,0,1,0,0,.7",
    transform: "translate(-5.663 -15.66)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4336",
    "data-name": "Path 4336",
    d: "M9.007,17.411h5.57a.35.35,0,0,0,0-.7H9.007a.35.35,0,1,0,0,.7",
    transform: "translate(-5.663 -10.931)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4337",
    "data-name": "Path 4337",
    d: "M9.007,10.182h1.954a.35.35,0,1,0,0-.7H9.007a.35.35,0,1,0,0,.7",
    transform: "translate(-5.663 -6.202)",
    fill: "#09c",
    stroke: "#09c",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordsIcon);
export default __webpack_public_path__ + "static/media/records-icon.28ca9d5d03a118d65aa1483b20b77e91.svg";
export { ForwardRef as ReactComponent };